<template>
    <div class="alert_banner_rsp">
          <div class="alert_icon">
            <img src="@/common/assets/styles/corp/images/LightBlack.png" class="alert_rsp_icon"/>
          </div>
          <div class="banner_text_rsp">
            <div class="banner_text_heading">You need to add a delivery method to continue.</div>
            <div class="banner_text_desc">This will help to avoid potential login issues in the future.</div>
          </div>
        </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import translations from "@/common/assets/json/messages1.json";

export default {
  name: "RSPAlertBanner",
  data() {
    return {
   
      
    };
  },
  mounted() {},
  methods: {
   
  },
  computed: {
   
  },
  watch: {
    
  },
};
</script>
<style>
.alert_banner_rsp{
  background-color: #FFF9DE;
  padding: 20px;
  display: flex;
  border-radius: 4px;
  margin: 20px 0px;
  max-width: 914px;
}
.alert_icon{
  margin-right: 12px;
}
.alert_rsp_icon{
  width: 20px;
  height: 20px;
}
.banner_text_heading{
  font-family: 'VzNHGeDS-bold11';
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  font-weight: 700;
  color: #000000;
}
.banner_text_desc{
  font-family: 'VzNHGeDS-reg11';
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  font-weight: 400;
  color: #000000;
}
</style>